import { View, LegacyBox, styled } from '@gogame/components';

import LinkRouter from 'scenes/MarketingPlanning/MarketingPlanningWizard/MarketingPlanningPreview/components/LinkRouter';

export const WizardViewStyled = styled(View)`
  height: calc(100vh - 64px);
`;

export const TableWrapperStyled = styled(LegacyBox)`
  width: 100%;
  overflow-x: auto;
  flex: 0 0 auto;
  z-index: 1;
  margin: -16px 0 16px;
`;

export const TotalBudgetBox = styled(LegacyBox)`
  min-width: 116px;
`;

export const NameBox = styled(LegacyBox)`
  min-width: 160px;
`;

export const NameLinkStyled = styled(LinkRouter)`
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: none;
`;
